
















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from './selectUrl.vue'
@Component({
  components: {
    PicModal,
    SelectUrl
  }
})
export default class Swiper extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {
        interval: 3000,
        imgUrl: []
      }
    }
  })
  SwiperConfig!: any

  mounted() {}

  /**
   * 选择图片
   */
  picChange(e, index) {
    this.SwiperConfig.imgUrl[index]['img'] = e[0].url
  }

  urlChange(e, index) {
    this.SwiperConfig.imgUrl[index]['url'] = e
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.SwiperConfig.imgUrl.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      img: null,
      url: null
    }
    this.SwiperConfig.imgUrl.unshift(obj)
  }
}
